import type {
  ArtistDetailsDataResponse,
  ArtistEntityType,
} from '~/modules/artist-roster/types';

/**
 * Function to get the artist entity type based on the data in the names array.
 *
 * Reference:
 * https://chat.google.com/room/AAAAyPLbnS4/Ikg7EiqyOvY/PDNnQfLZ25c?cls=10
 *
 * @param artist The artist object containing names and competencies.
 * @returns The artist entity type.
 */
export function getArtistEntityType(
  artist: ArtistDetailsDataResponse,
): ArtistEntityType {
  // First check for crossover artists.
  for (const name of artist.names) {
    if (name.is_crossover_artist) {
      return 'Crossover';
    }
  }

  // Not crossover, so now determine either Songwriter or Artist.
  for (const name of artist.names) {
    const { competency } = name;

    if (competency.length === 0) {
      continue;
    }

    if (competency.includes('SONGWRITER')) {
      return 'Songwriter';
    }

    if (
      competency.includes('PERFORMING_ARTIST') ||
      competency.includes('CONTRIBUTING_ARTIST')
    ) {
      return 'Artist';
    }
  }

  // Default to Artist.
  return 'Artist';
}
